import './SelectField.component.scss';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import { EDefaultWishList } from '../../../domain/wish.interface';

export function SelectFieldComponent({
  input,
  label,
  type,
  meta: { touched, error },
  propsOptions,
  errorTrigger,
}: any) {
  const [trigger, setTrigger] = useState(false);
  useEffect(() => setTrigger(errorTrigger), [errorTrigger]);

  function wishlistNameResolver(option: any) {
    if (!!option.isDefault) {
      return option.name === EDefaultWishList.MY_WISHES ? (
        <FormattedMessage key={option.id} id='pages.wishlist_catalogue.default_list_1'>
          {txt => (
            <option value={option.id}>
              {txt}
            </option>
          )}
        </FormattedMessage>
      ) : option.name === EDefaultWishList.RECOMMENDED ? (
        <FormattedMessage key={option.id} id='pages.wishlist_catalogue.default_list_2'>
          {txt => (
            <option value={option.id}>
              {txt}
            </option>
          )}
        </FormattedMessage>
      ) : (
        <option value={option.id} key={option.id}>
          {option.name}
        </option>
      );
    } else {
      return (
        <option value={option.id} key={option.id}>
          {option.name}
        </option>
      );
    }
  }

  return (
    <div className='field-container'>
      <div className='select-wrapper'>
        <select
          {...input}
          type={type}
          className={
            'field ' +
            ((touched || trigger) && error
              ? 'field-error'
              : touched
              ? 'field-success'
              : '')
          }
        >
          <option value={''}>{label}</option>
          {propsOptions &&
            propsOptions.map((option: any) => wishlistNameResolver(option))}
        </select>
        <FontAwesomeIcon icon='angle-down' className='select-arrow' />
      </div>
      <div className='message-container'>
        {(touched || trigger) && error && (
          <span className='field-error-message'>
            <FormattedMessage id={error.id} values={{ value: error.value }} />
          </span>
        )}
      </div>
    </div>
  );
}
